/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { ConstructionPlanAreaPlannedMaterialBase } from "../../../../schema/generated/ConstructionPlanAreaPlannedMaterial";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class ConstructionPlanAreaPlannedMaterialDataApi extends EntityDataApi<ConstructionPlanAreaPlannedMaterialBase> {
  public readonly def = idbEntityDefs.ConstructionPlanAreaPlannedMaterial;
}